import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Grid,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook"; // Use Firestore hook
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  // Use Firestore hook with the specified collection name "TpCreditType"
  const { addData } = useFirestore("TpCreditType");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [formData, setFormData] = useState({
    Credit_Type_abv: "",
    Credit_Type_Name: "",
    Note: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use addData from useFirestore
      setLoading(false);
      setSnackbarOpen(true);
      setFormData({
        Credit_Type_abv: "",
        Credit_Type_Name: "",
        Note: "",
      });
      setOpen(false);
      onRecordAdded(); // Call the callback function to refresh the list
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Record
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <ModalDialogTitle onClose={handleClose}>Add Record</ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Credit Type Abv"
                name="Credit_Type_abv"
                value={formData.Credit_Type_abv}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Credit Type Name"
                name="Credit_Type_Name"
                value={formData.Credit_Type_Name}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
              <TextField
                label="Note"
                name="Note"
                value={formData.Note}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="Record has been added"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          sx: {
            backgroundColor: "black",
            color: "white",
          },
        }}
      />
    </div>
  );
};

export default Add;
